<template>
  <div class="table-container">
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <div v-if="ok">
          <validation-observer
            ref="observer"
            v-slot="{ invalid, handleSubmit }"
          >
            <b-form @submit.prevent="">
              <div class="form-card-wrapper">
              <b-card header-tag="header">
                <template #header>
                  <b>Dati Generali</b>
                </template>
                <b-card-text>
                  <b-row>
                    <div class="form-group">
                      <base-input
                        vid="email"
                        :name="beForm[rep].email.label"
                        :label="beForm[rep].email.label"
                        v-model="form[rep].email"
                        placeholder="Inserisci una email"
                        :rules="{ email: true }"
                      />
                    </div>
                    <div class="form-group">
                      <base-input
                        vid="username"
                        :name="beForm[rep].username.label"
                        :label="beForm[rep].username.label"
                        v-model="form[rep].username"
                        placeholder="Inserisci uno username"
                      />
                    </div>
                    <div class="form-group">
                      <base-input
                        vid="description"
                        :name="beForm[rep].description.label"
                        :label="beForm[rep].description.label"
                        v-model="form[rep].description"
                        placeholder="Inserisci una descrizione"
                      />
                    </div>
                    <div class="form-group">
                      <b-button-toolbar>
                        <b-button-group>
                          <base-input
                            name="password"
                            vid="password"
                            label="Password"
                            v-model="form[rep].password"
                            :type="showPassword ? 'text' : 'password'"
                            autocomplete="off"
                          />
                          <b-button
                            class="mt-4 btn-quick"
                            size="sm"
                            text="Button"
                            variant="lisaweb"
                            :title="buttonLabel"
                            @click="toggleShow"
                            :rules="getRules('password', 'user')"
                          >
                            <b-icon icon="eye" v-if="!showPassword"></b-icon>
                            <b-icon v-else icon="eye-slash-fill"></b-icon
                            >
                          </b-button>
                        </b-button-group>
                      </b-button-toolbar>
                    </div>
                    <div class="form-group">
                      <base-select
                        vid="is_limited"
                        :name="beForm[rep].is_limited.label"
                        :label="getDictionary('is_limited', rep)"
                        v-model="form[rep].is_limited"
                        :options="beForm[rep].is_limited.options"
                        :taggable="false"
                        :multiple="false"
                        :closeOnSelect="true"
                        :rules="getRules('is_limited')"
                      />
                      <!-- :disabled="!isAdmin()" -->
                    </div>
                  </b-row>
                </b-card-text>
              </b-card>
              </div>
              <div class="form-actions form-actions--sticky">
                <div class="inner-wrapper">
                  <div>
      <span
        :title="`${
          invalid
            ? 'Compila correttamente i campi per poter salvare'
            : 'Invia il form'
        }`"
      >
        <b-button
          @click="handleSubmit(onSubmit)"
          type="button"
          :disabled="invalid"
          variant="lisaweb"
          size="sm"
          :title="`${
            invalid
              ? 'Compila correttamente i campi per poter salvare'
              : 'Invia il form'
          }`"
        >
          Salva
        </b-button>
      </span>
                    <b-button
                      @click="resetForm()"
                      class="btn--transparent btn-reset"
                      type="button"
                      title="Pulisci tutti i campi e compila il form nuovamente"
                    >Reset
                    </b-button
                    >
                  </div>
                  <div>
                    <b-button
                      @click="goBack()"
                      class="btn--transparent"
                      type="button"
                      title="Torna alla pagina precedente"
                    >
                      <b-icon-chevron-double-left
                        font-scale="0.9"
                      ></b-icon-chevron-double-left
                      >
                      Torna indietro
                    </b-button
                    >
                  </div>
                </div>
              </div>
            </b-form>
          </validation-observer>
        </div>
        <div v-else>
          {{ errorMessage }}
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import BaseInput from "@/components/form/BaseInput";
import BaseSelect from "@/components/form/BaseSelect";
import ShortcutMixin from "@/mixins/ShortcutMixin";
import FormMixin from "@/mixins/FormMixin";
// import { isAdmin } from "@/utils/permissions";

export default {
  mixins: [FormMixin, ShortcutMixin],
  data() {
    return {
      repository: "user",
      id: this.$route.params.id,
      showPassword: false,
      form: {
        user: {
          username: null,
          email: null,
          password: null,
          role_id: null,
          is_limited: null,
          description: null,
        },
      },
    };
  },
  components: {
    BaseInput,
    BaseSelect,
  },
  methods: {
    // isAdmin,
    goBack() {
      if (this.returnUrl) {
        switch (this.returnUrl) {
          case "profile-users-create":
            this.$router.push({
              name: "users.create",
            });
            break;
          default:
            console.log(
              "No returnUrl set matched! Fallback to default back behavior."
            );
            this.$router.back();
            break;
        }
      } else {
        this.$router.back();
      }
    },
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    onSubmit() {
      this.loadMsg();
      this.isLoading = true;
      this.store(this.repository)
        .then(() => {
          this.$showSnackbar({
            preset: "success",
            text: `Azione Completata: Utente creato`,
          });
          this.shortcut("users.index", null, null, "filterUsers");
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        })
        .finally(() => {
          this.unloadMsg();
          this.isLoading = false;
        });
    },
  },
  created() {
    this.isLoading = true;
    this.fetchCreateForm(this.repository).then(() => {
      this.form[this.rep].role_id = this.beForm[this.rep].role_id.options.find(
        (role) => role.text === "operatore"
      ).value;
      this.isLoading = false;
    });
  },
  computed: {
    buttonLabel() {
      return this.showPassword ? "Nascondi" : "Mostra";
    },
    rep() {
      return this.repository;
    },
  },
};
</script>
